import { SomethingNew, getStaticProps } from '@public/SomethingNew'

export { getStaticProps }

export default SomethingNew
